/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import {SortModelType} from '@ion/dls/src/grid/IonGridUtils';

// defining the page sizes of the tracking grid...
export const TRACKING_PAGE_SIZES = [5, 15, 25];
  
// Mapping of UI attribute names to data attribute names.
export const attributeMappings = {
  operatorNamesUI         : 'operatorNames',
  typeUI                  : 'assetType',
  eventTimeUI             : 'eventTime',
  latestEventUI           : 'eventType',
  eventTypeUI             : 'eventType',
  odometerUI              : 'odometer',
  gpsOdometerUI           : 'gpsOdometer',
  vbOdometerUI            : 'vbOdometer',
  engineHourUI            : 'engineHour',
  engineHoursGPSUI        : 'engineHours',
  fuelTypeUI              : 'fuelType',
  idleHoursUI             : 'idleHours',
  engineLightUI           : 'vbusMilStatus',
  vbatIntUI               : 'adcDeviceBatteryVoltage',
  vbatExtUI               : 'adcExternalPowerVoltage',
  batteryUI               : 'evBatteryPackRemainingCharge',
  ignitionUI              : 'ignition',
  input1UI                : 'input1',
  input2UI                : 'input2',
  input3UI                : 'input3',
  input4UI                : 'input4',
  input5UI                : 'input5',
  input6UI                : 'input6',
  input7UI                : 'input7',
  gpsValidityUI           : 'gpsValidity',
  commStateAvailableUI    : 'commStateAvailable',
  gpsSpeedUI              : 'gpsSpeed',
  vbSpeedUI               : 'vbSpeed',
  latitudeUI              : 'latitude',
  longitudeUI             : 'longitude',
  speedUI                 : 'speed',
  addressUI               : 'street',
  altitudeUI              : 'altitude',
  routeNameUI             : 'routeName',
  assetNameUI             : 'assetName',
  deviceEsnUI             : 'deviceIdValue',
  location                : 'location',
  deviceNameUI            : 'deviceName',
  deviceType              : 'deviceType',
  batteryRemainingPercent : 'batteryRemainingPercent',
  stateUI                 : 'assetStatus'
};
    
// Default sorting configuration for the grid.
export const defaultSort: SortModelType = {
  colId : 'eventTimeUI',
  sort  : 'desc'
};
